import { Link } from 'react-router-dom';
import { LazyImage } from '../common/LazyImage';

interface LogoProps {
  isExpanded: boolean;
  isCentered: boolean;
}

export function Logo({ isExpanded, isCentered }: LogoProps) {
  return (
    <Link
      to="/"
      className={`
        flex items-center gap-2.5 group transition-all duration-700 ease-out
        ${isExpanded ? 'justify-start' : isCentered ? 'justify-center w-full' : 'justify-center'}
      `}
    >
      <div className="logo-icon w-10 h-10 rounded-xl bg-gradient-to-br from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
        {/* <Terminal className="w-6 h-6 text-white transform transition-transform duration-300 group-hover:rotate-12" /> */}
        <LazyImage src="mocktrail-logo.png" alt="MockTrail Logo" className="w-8 h-8" />
      </div>
      <h1
        className={`
          text-2xl font-heading font-bold gradient-text transition-all duration-700 ease-out mt-1
          ${isCentered ? 'opacity-100 scale-100 translate-x-0' : isExpanded ? 'opacity-100 scale-100 translate-x-0' : 'opacity-0 scale-95 -translate-x-4 absolute'}
        `}
      >
        MockTrail
        <span className="relative -top-[12px] ml-1 text-[9px] text-text-secondary-light dark:text-text-secondary-dark font-heading">TM</span>
      </h1>
    </Link>
  );
}